/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardScopeNode {
    getFixupPrototypeFunction() { return DashboardScopeNode.fixupPrototype; }

    static newInstance(model: Partial<DashboardScopeNode>): DashboardScopeNode {
        let obj = Object.assign(new DashboardScopeNode(), model);
        DashboardScopeNode.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardScopeNode>): DashboardScopeNode {
        if (!model) return null;
        return DashboardScopeNode.newInstance(<DashboardScopeNode> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardScopeNode) {
        if (!obj) return;

        models.DashboardScopeNode.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardScopeNode): boolean {
        Object.setPrototypeOf(obj, DashboardScopeNode.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.condition) {
            models.QueryOperator.fixupPrototype(this.condition);
        }
    }

    /**
     * whether filter dimension remains configurable in the dashboard
     */
    visible: boolean;

    condition: models.QueryOperator;

}
